"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const http_1 = require("http");
const stream_1 = require("stream");
const content_type_1 = __importDefault(require("content-type"));
const errors_1 = require("./errors");
const { NODE_ENV } = process.env;
const DEV = NODE_ENV === 'development';
const jsonStringify = DEV ? (obj) => JSON.stringify(obj, null, 2) : (obj) => JSON.stringify(obj);
const isReadable = (stream) => typeof stream === 'object' &&
    typeof stream.pipe === 'function' &&
    stream.readable !== false &&
    typeof stream._read === 'function' &&
    typeof stream._readableState === 'object';
function send(res, statusCode, obj = null) {
    res.statusCode = statusCode;
    if (obj === null) {
        res.end();
        return;
    }
    if (Buffer.isBuffer(obj)) {
        if (!res.getHeader('Content-Type')) {
            res.setHeader('Content-Type', 'application/octet-stream');
        }
        res.setHeader('Content-Length', obj.length);
        res.end(obj);
        return;
    }
    if (obj instanceof stream_1.Stream || isReadable(obj)) {
        if (!res.getHeader('Content-Type')) {
            res.setHeader('Content-Type', 'application/octet-stream');
        }
        obj.pipe(res);
        return;
    }
    let str = obj;
    const typeObj = typeof obj;
    if (typeObj === 'object' || typeObj === 'number') {
        str = jsonStringify(obj);
        if (!res.getHeader('Content-Type')) {
            res.setHeader('Content-Type', 'application/json; charset=utf-8');
        }
    }
    res.setHeader('Content-Length', Buffer.byteLength(str));
    res.end(str);
}
exports.send = send;
function isAcceptJson(headers) {
    const { accept } = headers;
    let type = '*/*';
    try {
        const ct = content_type_1.default.parse(accept || type);
        type = ct.type || '*/*';
    }
    catch (err) {
    }
    return type === '*/*' || accept === 'application/json';
}
exports.sendError = (req, res, errorObj) => {
    const acceptJson = isAcceptJson(req.headers);
    let statusCode = 500;
    let body = acceptJson
        ? {
            error: {
                code: 'internal_server_error',
                message: 'Internal Server Error',
            },
        }
        : 'Internal Server Error';
    if (errorObj instanceof errors_1.MicriError) {
        statusCode = errorObj.statusCode || 500;
        const code = errorObj.code || 'internal_server_error';
        if (acceptJson) {
            if (DEV) {
                body = {
                    error: {
                        code,
                        message: errorObj.message,
                        stack: errorObj.stack,
                        originalError: errorObj.originalError || null,
                    },
                };
            }
            else {
                const message = errorObj.message || 'Internal Server Error';
                body = {
                    error: {
                        code,
                        message,
                    },
                };
            }
        }
        else {
            const message = errorObj.message || 'Internal Server Error';
            body = DEV ? errorObj.stack : message;
        }
    }
    else if (errorObj instanceof Error) {
        console.error(errorObj);
    }
    else {
        console.warn('thrown error must be an instance Error');
    }
    send(res, statusCode, body);
};
function run(req, res, fn) {
    return new Promise((resolve) => resolve(fn(req, res)))
        .then((val) => {
        if (val === null) {
            send(res, 204, null);
            return;
        }
        if (val !== undefined) {
            send(res, res.statusCode || 200, val);
        }
    })
        .catch((err) => exports.sendError(req, res, err));
}
exports.run = run;
exports.serve = (fn) => http_1.createServer((req, res) => run(req, res, fn));
//# sourceMappingURL=data:application/json;base64,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